import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { City } from '../models/cities.model';
import * as citiesSelectors from '../store/selectors/cities.selector';
import * as citiesActions from '../store/actions/cities.action';

@Injectable({
    providedIn: 'root'
})
export class CitiesService {
    cities: City[] = [];
    userSelectedCity: City;
    userSelectedCityId: number;
    private cityChangeSubject = new Subject<City>();
  
    cityChange$ = this.cityChangeSubject.asObservable();
  
    constructor(private http: HttpClient, private store: Store) {
      this.store.select(citiesSelectors.selectCities).subscribe(cities => {
        this.cities = cities;
       
      });
    }
  
    setCities(cities: City[]) {
     
      this.cities = cities;
      localStorage.setItem('cities', JSON.stringify(cities));
    }
  
    getCities(): any {
      const cities = localStorage.getItem('cities');
      if (cities) {
        this.cities = JSON.parse(cities);
        return this.cities;
      }
      return [];
    }
  
    setUserSelectedCity(city: City): any {
  
      this.userSelectedCity = city;
      this.userSelectedCityId = city.id;
      localStorage.setItem('userSelectedCity', JSON.stringify(city));
      localStorage.setItem('userSelectedCityId', city.id.toString());
      this.store.dispatch(citiesActions.setUserSelectedCityId({ city_id: city.id }));
      this.cityChangeSubject.next(city); 
        
    }
  
    getUserSelectedCity(): City {
      const city = localStorage.getItem('userSelectedCity');
      if (city) {
        this.userSelectedCity = JSON.parse(city);
        return this.userSelectedCity;
      }
      return null;
    }
  
    getUserSelectedCityId(): string {
      const cityId = localStorage.getItem('userSelectedCityId');
      if (cityId) {
        this.userSelectedCityId = parseInt(cityId, 10);
        return this.userSelectedCityId.toString();
      }
      return null;
    }
  }